export default [
    { type: 'qr', name: 'QR' },
    { type: 'card', name: 'Card' },
    { type: 'redemption', name: 'Redemption' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/custom/mpay-payment-types.js